import { Controller } from "@hotwired/stimulus";

// The conversations page's search field. Typing submits the form into the
// results frame after a pause, so the field itself never re-renders and keeps
// its caret. Escape clears a query without reaching the panel, which closes
// on Escape.
export default class extends Controller<HTMLFormElement> {
  static targets = ["input", "clear"];
  static values = { debounce: { type: Number, default: 250 } };

  declare readonly inputTarget: HTMLInputElement;
  declare readonly clearTarget: HTMLElement;
  declare debounceValue: number;
  private timer?: number;

  connect(): void {
    this.toggleClear();
  }

  disconnect(): void {
    window.clearTimeout(this.timer);
  }

  changed(): void {
    this.toggleClear();
    window.clearTimeout(this.timer);
    this.timer = window.setTimeout(() => this.element.requestSubmit(), this.debounceValue);
  }

  keydown(event: KeyboardEvent): void {
    if (event.key !== "Escape" || this.inputTarget.value === "") return;
    event.preventDefault();
    event.stopPropagation();
    this.clear();
  }

  clear(): void {
    this.inputTarget.value = "";
    this.inputTarget.focus();
    this.toggleClear();
    window.clearTimeout(this.timer);
    this.element.requestSubmit();
  }

  private toggleClear(): void {
    this.clearTarget.hidden = this.inputTarget.value === "";
  }
}
